/* Heimatgut consent gate for hardcoded third-party scripts.
   Consentmo blocks app-embedded and Shopify-pixel scripts, but not scripts written
   straight into the theme. Those are parked as inert <script type="text/plain">
   placeholders and only turned into real scripts once Shopify's Customer Privacy
   API reports consent for their category (TDDDG §25 / GDPR Art. 6).

   Markup for an external file:
     <script type="text/plain"
             data-consent-category="marketing"
             data-src="//example.com/tag.js"></script>

   Markup for inline bootstrap code (e.g. a vendor snippet that loads its own
   asset, like PostHog's init snippet) — same idea, code lives in the body
   instead of data-src:
     <script type="text/plain" data-consent-category="analytics">
       posthog.init(...)
     </script>

   Categories map to the Customer Privacy API: marketing → marketingAllowed(),
   analytics → analyticsProcessingAllowed(), preferences → preferencesAllowed().
   Outside consent-required regions Shopify reports these as true, so the scripts
   keep loading normally there. */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return; // no third-party tags in the editor

  var SELECTOR = 'script[type="text/plain"][data-consent-category]';

  function allowed(category) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      if (category === 'analytics' && typeof cp.analyticsProcessingAllowed === 'function') {
        return !!cp.analyticsProcessingAllowed();
      }
      if (category === 'preferences' && typeof cp.preferencesAllowed === 'function') {
        return !!cp.preferencesAllowed();
      }
      if (typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed();
    } catch (e) {}
    return false; // no API, no answer → treat as no consent
  }

  function activate() {
    var placeholders = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < placeholders.length; i++) {
      var placeholder = placeholders[i];
      if (!allowed(placeholder.getAttribute('data-consent-category'))) continue;

      var script = document.createElement('script');
      var src = placeholder.getAttribute('data-src');
      if (src) {
        script.src = src;
        script.async = true;
      } else {
        script.textContent = placeholder.textContent;
      }
      placeholder.parentNode.insertBefore(script, placeholder.nextSibling);
      placeholder.parentNode.removeChild(placeholder); // loaded once, never twice
    }
  }

  var PRIVACY_API_RETRY_LIMIT = 10;
  var PRIVACY_API_RETRY_DELAY = 300; // ms; ~3s total across all attempts

  // For a returning visitor whose consent is already stored, the banner never
  // fires and no visitorConsentCollected event follows — this is the only chance
  // to activate gated scripts on that pageview. If the API and loadFeatures are
  // both unavailable (or loadFeatures errors), the API may just not be ready yet,
  // so retry a bounded number of times before giving up silently.
  function withPrivacyApi(cb, attempt) {
    var called = false;
    function callOnce() {
      if (called) return;
      called = true;
      cb();
    }

    try {
      if (window.Shopify && window.Shopify.customerPrivacy) { callOnce(); return; }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (err) {
            if (!err) { callOnce(); return; }
            retry();
          }
        );
        return;
      }
    } catch (e) {}

    retry();

    function retry() {
      var nextAttempt = (attempt || 0) + 1;
      if (nextAttempt >= PRIVACY_API_RETRY_LIMIT) return; // give up silently
      setTimeout(function () { withPrivacyApi(cb, nextAttempt); }, PRIVACY_API_RETRY_DELAY);
    }
  }

  // Once on load for returning visitors, and again whenever consent is collected or
  // changed in this session — the banner does not reload the page.
  withPrivacyApi(activate);
  document.addEventListener('visitorConsentCollected', function () { withPrivacyApi(activate); });
})();
